/* eslint-disable react/no-deprecated */
/* eslint-disable no-restricted-globals */
import React, { Component } from 'react';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import MuiListItem from '@material-ui/core/ListItem';
import Add from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Switch from '../Switch';
import 'rc-time-picker/assets/index.css';
import 'react-datepicker/dist/react-datepicker.css';
import { DAYS, DEFAULT_SLOT_INTERVAL, SAVE_BUTTON_TEXT, settings, UNIT } from '../../constants';
import Input from '../Input';
import Paper from '../Paper';
import Button from '../Button';
import IconButton from '../IconButton';
import Spinner from '../Spinner';
import * as actions from '../../actions/index';
import {
  handleChangeOpenHours,
  handleChangeSwitch,
  handleAddHours,
  handleRemoveHours,
  initDataConfig,
  handleSubmitData,
  getUniqueSlotId
} from './HoursConfig.services';
import { styles } from './HoursConfig.styles';
import BackButton from '../BackButton';
const ListItemHours = withStyles({
  root: {
    paddingLeft: '12px',
    paddingBottom: '5px',
    paddingTop: '0px',
    paddingRight: '4px'
  }
})(MuiListItem);

const INITIAL_STATE = {
  isLoading: false,
  data: {},
  techs: {},
  updateModalConfig: false,
  updatePaimentModalConfig: false,
  updateContactConfig: false,
  checkBox: {
    Monday: true,
    Tuesday: true,
    Wednesday: true,
    Thursday: true,
    Friday: true,
    Saturday: true,
    Sunday: true
  },
  slotErrorMessages: {}
};
class HoursConfig extends Component {
  constructor() {
    super();
    this.state = INITIAL_STATE;
  }

  componentDidMount() {
    initDataConfig(this.props, this);
  }

  componentWillReceiveProps(nextProps) {
    const { configurations: oldConfigs = {} } = this.props;
    const { data } = this.state;
    const { openHours } = data;
    const { configurations = {} } = nextProps;
    const { hours: oldHours = {} } = oldConfigs;
    const { hours = {} } = configurations;
    if ((!_.isEqual(oldHours, hours) && !_.isEqual(hours, openHours))) {
      initDataConfig(nextProps, this);
    }
  }

  renderConfigHours = type => {
    const { classes, hours = {}, sidebarCollapse } = this.props;
    const { checkBox, data = {}, isLoading, slotType } = this.state;
    const { openHours } = data;
    const { slotInterval = DEFAULT_SLOT_INTERVAL } = hours;
    const returnComponents = [];
    {
      _.size(openHours) > 0 &&
      returnComponents.push(
        <Paper className={`col-12 ${sidebarCollapse && 'col-lg-10'} py-3 ${classes.paperStyle}`}>
          {
            _.keys(DAYS).map((e, i) => {

              const { slots = {}, slotsDelivery = {} } = openHours[e];
              const slot = type === 'slots' ? slots : slotsDelivery;
              return (
                <>
                  {i !== 0 && <div className={classes.separator} />}
                  <div
                    key={e}
                    className='row d-flex align-items-center justify-content-between mx-0 mx-sm-3'
                  >
                    <div className='d-flex align-items-center justify-content-center'>
                      <Switch
                        onChange={() => handleChangeSwitch(e, type, this)}
                        checked={checkBox[e]}
                      />
                      <div className={classes.dayLabel}>{DAYS[e]}</div>
                    </div>
                    <div className=' d-flex align-items-center'>
                      <IconButton
                        label='Add'
                        className={classes.icon}
                        onClick={() => handleAddHours(e, type, this)}
                      >
                        <Add className={classes.removeIcon} />
                      </IconButton>
                      <div className={classes.slotLabel}>
                        <div className='d-none d-sm-block mr-1'>Ajouter un créneau</div>
                        <div className='d-sm-none mr-1'>Créneau</div>
                      </div>
                    </div>
                  </div>
                  <div>
                    {slot &&
                      _.map(slot, (f, slotKey) => {
                        const limit = type === 'slots' ? f.limit : f.limitDelivery;
                        const slotId = getUniqueSlotId(e, slotKey, type);
                        const errorMessage = this.state.slotErrorMessages[slotId];
                        return (
                          <ListItemHours
                            key={slotKey}
                            className='row justify-content-center align-items-center py-2 ml-0 mr-0 px-0 px-md-3'
                          >
                            <div className='row ml-0 mr-0'>
                              <div className='col-12 col-sm-6 row ml-0 mr-0 px-0 justify-content-center justify-content-sm-start align-items-center'>
                                <Input
                                  type='time'
                                  value={f.start}
                                  onChange={event =>
                                    handleChangeOpenHours(
                                      e,
                                      slotKey,
                                      event.target.value,
                                      type,
                                      'start',
                                      this
                                    )
                                  }
                                  error={errorMessage}
                                  className={classes.textField}
                                  InputLabelProps={{
                                    shrink: true
                                  }}
                                />
                                <div className={classes.textStyle}>à</div>
                                <Input
                                  type='time'
                                  value={f.end}
                                  onChange={event =>
                                    handleChangeOpenHours(
                                      e,
                                      slotKey,
                                      event.target.value,
                                      type,
                                      'end',
                                      this
                                    )
                                  }
                                  error={errorMessage}
                                  className={classes.textField}
                                  InputLabelProps={{
                                    shrink: true
                                  }}
                                />
                                <div className={errorMessage ? `${classes.errorMessage} col-12` : ''}>{errorMessage}</div>
                              </div>
                              <div className='col-12 col-sm-6 row ml-0 mr-0 px-0 justify-content-center justify-content-sm-end align-items-center'>
                                <div
                                  key={e}
                                  className='d-flex align-items-center justify-content-center ml-md-2'
                                >
                                  <div className={classes.limitLabel}>
                                    <div className=' mr-1'>Commandes</div>/ {slotInterval}min :
                                  </div>
                                  <Input
                                    id='limit'
                                    className={classes.limitInput}
                                    type='number'
                                    value={limit <= 0 ? 0 : limit}
                                    onChange={event =>
                                      handleChangeOpenHours(
                                        e,
                                        slotKey,
                                        event.target.value,
                                        type,
                                        type === 'slots' ? 'limit' : 'limitDelivery',
                                        this
                                      )
                                    }
                                    InputLabelProps={{
                                      shrink: true
                                    }}
                                    classes={{ label: classes.labelStyle }}
                                  />
                                </div>

                                <div className='col- d-flex align-items-end justify-content-center'>
                                  <IconButton
                                    size='small'
                                    label='Remove'
                                    disabled={slot.length === 1}
                                    onClick={() => handleRemoveHours(e, slotKey, type, this)}
                                    style={{
                                      alignSelf: 'flex-end',
                                      backgroundColor: 'transparent'
                                    }}
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                </div>
                              </div>
                            </div>
                          </ListItemHours>
                        );
                      })}
                  </div>
                </>
              );

            })}
          <div className='d-flex w-100 justify-content-center justify-content-sm-end align-items-center p-4'>
            <div className={`px-sm-${isLoading ? 5 : 0} `}>
              {isLoading ? (
                <Spinner size={30} />
              ) : (
                <Button
                  color='primary'
                  onClick={e => handleSubmitData(e, this)}
                  className=' btn-primary'
                >
                  <div className='row justify-content-center align-items-center mr-0 ml-0'>
                    <p className='mx-0'>{SAVE_BUTTON_TEXT}</p>
                  </div>
                </Button>
              )}
            </div>
          </div>
        </Paper>
      );
    }
    return returnComponents;
  };

  render() {
    const { slotType } = this.state;
    const { history = {} } = this.props;

    return (
      <div className='p-4'>
        <BackButton
          className='pl-0'
          onClick={() => history.goBack()}
          title={slotType === 'slots' ? settings.openedHours.text : settings.deliveryHours.text}
          subtitle={
            slotType === 'slots'
              ? settings.openedHours.description
              : settings.deliveryHours.description
          }
        />
        {this.renderConfigHours(slotType)}
      </div>
    );
  }
}

function mapStateToProps({ firebaseRealTime, sidebar }) {
  const { generalConfig, shop } = firebaseRealTime;
  const { hours } = generalConfig;
  const { sidebarCollapse } = sidebar;
  return {
    configurations: shop,
    hours,
    sidebarCollapse
  };
}
HoursConfig.propTypes = {
  classes: PropTypes.element.isRequired
};
export default connect(mapStateToProps, actions)(withStyles(styles)(withRouter(HoursConfig)));